import * as React from 'react';
import { Anchor, Box, IconButton, Skeleton, Text } from '@moosend/mooskin';

export interface ISnapshotItem {
	optional?: boolean;
	status?: boolean;
	editLabel?: string;
	isLoading?: boolean;
	content: string | JSX.Element | Element;
	onClickEdit: () => void;
}

export const SnapshotItem: React.FC<ISnapshotItem> = (props) => {
	return (
		<Box mb={30}>
			<Skeleton isLoaded={!props.isLoading}>
				<Box d="flex" align="center">
					<IconButton
						mr={10}
						fontColor={props.status ? 'fontColors.secondary1' : props.optional ? 'fontColors.medgray1' : 'fontColors.primary4'}
					>
						{props.status ? 'check_circle_outline' : 'highlight_off'}
					</IconButton>
					<Text fontSize={14} wordBreak="break-word">
						{props.content}
					</Text>
				</Box>
			</Skeleton>
			<Skeleton isLoaded={!props.isLoading} noRender={['sm', 'xs']}>
				<Anchor mt={15} ml={30} onClick={props.onClickEdit} noRender={['sm', 'xs']}>
					{props.editLabel || 'Edit'}
				</Anchor>
			</Skeleton>
		</Box>
	);
};

SnapshotItem.displayName = 'SnapshotItem';
